<template>
  <div id="modalGdprSetupRoute">
    <modal
      :name="modalName"
    >
      <div class="modal-header">
        <div class="modal-header__text">
          <h4 class="bold">
            {{ $t("Select Cookies") }}
          </h4>
        </div>
        <div class="modal-header__right">
          <button
            class="button p12 inline-flex"
            @click="close"
          >
            <span class="icon fs10 c-gray-darkest icon-close" />
          </button>
        </div>
      </div>
      <gdpr-cookie-setup :gdpr-cookie-setup-data="gdprCookieSetupData" />
    </modal>
  </div>
</template>

<script>
import Modal from 'theme/components/core/Modal'
import GdprCookieSetup from './GdprCookieSetup'
import ScrollLock from 'theme/mixins/scrollLock'
import { MODAL_NAME } from 'src/modules/gdpr-cookie-setup'

export default {
  components: {
    Modal,
    GdprCookieSetup
  },
  mixins: [ScrollLock],
  props: {
    gdprCookieSetupData: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      modalName: MODAL_NAME
    }
  },
  beforeMount () {
    this.$bus.$on('modal-show', this.onModalShow)
  },
  beforeDestroy () {
    this.$bus.$off('modal-show', this.onModalShow)
  },
  methods: {
    /**
     * @param {String} name
     * @return {void}
     */
    onModalShow (name) {
      if (name === MODAL_NAME) {
        this.disableBodyScroll()
      }
    },
    close () {
      this.$bus.$emit('modal-hide', MODAL_NAME)
      this.clearAllBodyScrollLocks()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~theme/css/base/global_vars";
@import "~theme/css/variables/colors";
@import "~theme/css/variables/grid";
@import "~theme/css/helpers/functions/color";
@import "~theme/css/helpers/functions/z-index-selectors";

#modalGdprSetupRoute {
  /deep/ .modal {
    z-index: zIndex(cookie-modal);
  }

  /deep/ .modal-container {
    display: flex;
    flex-direction: column;
    margin: 0 10px;
    border-radius: 20px;
    max-width: 600px;
  }

  .modal-header {
    padding: 40px 40px 0;
    margin: 0;
    display: flex;
    justify-content: space-between;

    button {
      background-color: color(white);
      border: none;
      padding: 0;
    }

    .modal-header__right {
      display: flex;
      align-items: center;

      span {
        font-size: 24px;
        color: #6c6c6c;
      }
    }
  }

  .modal-header__text {
    h4 {
      font-size: 32px;
      line-height: 48px;
      margin: 0;
    }
  }

  @include mobile {
    /deep/ .modal {
      .modal-container {
        max-width: 100%;
        width: 100%;
        height: 100%;
        margin: 0;
        border-radius: 0;

        .modal-content {
          padding: 20px 15px 15px 15px;
        }
      }

      .modal-header__right {
        span {
          font-size: 18px;
        }
      }
    }

    .modal-header {
      padding: 15px 15px 0;
      margin: 0;
      display: flex;
      justify-content: space-between;
    }

    .modal-header__text {
      h4 {
        font-size: 22px;
        line-height: 27px;
        margin: 0;
      }
    }
  }
}

</style>
